module.exports = __webpack_public_path__ + "media/images/invoice-example-de7626023af9c3641d23e4f4b004d435.png";